module.exports = __webpack_public_path__ + "img/8.604da2f5.png";